/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum PartyConfigurationFaultEnum {
  "PPT_STAZIONE_INT_PA_IRRAGGIUNGIBILE" = "PPT_STAZIONE_INT_PA_IRRAGGIUNGIBILE",

  "PPT_STAZIONE_INT_PA_TIMEOUT" = "PPT_STAZIONE_INT_PA_TIMEOUT",

  "PPT_STAZIONE_INT_PA_ERRORE_RESPONSE" = "PPT_STAZIONE_INT_PA_ERRORE_RESPONSE",

  "PPT_IBAN_NON_CENSITO" = "PPT_IBAN_NON_CENSITO",

  "PAA_SINTASSI_EXTRAXSD" = "PAA_SINTASSI_EXTRAXSD",

  "PAA_SINTASSI_XSD" = "PAA_SINTASSI_XSD",

  "PAA_ID_DOMINIO_ERRATO" = "PAA_ID_DOMINIO_ERRATO",

  "PAA_ID_INTERMEDIARIO_ERRATO" = "PAA_ID_INTERMEDIARIO_ERRATO",

  "PAA_STAZIONE_INT_ERRATA" = "PAA_STAZIONE_INT_ERRATA",

  "PAA_ATTIVA_RPT_IMPORTO_NON_VALIDO" = "PAA_ATTIVA_RPT_IMPORTO_NON_VALIDO",

  "PPT_ERRORE_EMESSO_DA_PAA" = "PPT_ERRORE_EMESSO_DA_PAA",

  "PAA_SYSTEM_ERROR" = "PAA_SYSTEM_ERROR"
}

/**
 * Fault codes for fatal errors from ECs, should be mapped to 503 HTTP status code.
 * For further information visit https://docs.pagopa.it/gestionedeglierrori/struttura-degli-errori/fault-code.
 * Possible fault codes are:
 * - `PPT_STAZIONE_INT_PA_IRRAGGIUNGIBILE`
 * - `PPT_STAZIONE_INT_PA_TIMEOUT`
 * - `PPT_STAZIONE_INT_PA_ERRORE_RESPONSE`
 * - `PPT_IBAN_NON_CENSITO`
 * - `PAA_SINTASSI_EXTRAXSD`
 * - `PAA_SINTASSI_XSD`
 * - `PAA_ID_DOMINIO_ERRATO`
 * - `PAA_ID_INTERMEDIARIO_ERRATO`
 * - `PAA_STAZIONE_INT_ERRATA`
 * - `PAA_ATTIVA_RPT_IMPORTO_NON_VALIDO`
 * - `PPT_ERRORE_EMESSO_DA_PAA`
 * - `PAA_SYSTEM_ERROR`
 */

export type PartyConfigurationFault = t.TypeOf<typeof PartyConfigurationFault>;
export const PartyConfigurationFault = enumType<PartyConfigurationFaultEnum>(
  PartyConfigurationFaultEnum,
  "PartyConfigurationFault"
);
